<template>
  <div>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="field">
            <p><router-link v-bind:to="'/products/create'" class="button is-info">Create new product</router-link></p>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.productsTotal | numberDisplay }}</strong> products</p>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Slug</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.products.length">
          <td colspan="5" class="has-text-centered has-text-grey">No products found</td>
        </tr>
        <tr v-for="item in this.$store.state.products">
          <td>{{ item.id }}</td>
          <td><router-link v-bind:to="`/products/${item.id}`">{{ item.name }}</router-link></td>
          <td>{{ item.slug }}</td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage: function () {
        return Math.ceil(this.$store.state.productsTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      }
    },

    created () {
      this.$store.dispatch('getOrganizationProducts', {
        organizationId: this.$store.state.organizationId,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getOrganizationProducts', {
          organizationId: this.$store.state.organizationId,
          params: this.$route.query
        })
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// ProductList.vue?47fb0d1a